export default (request) => ({
  returnsById: (indexId, options) => request({
    method: 'get',
    url: `/indexes/${indexId}/returns`,
    ...options,
  }),
});
